// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"ed982816","294":"fcdc5167","376":"d4780690","453":"8cf5e88c","455":"51e7d0a0","741":"da46b06a","977":"12435178","983":"2532665e"}[chunkId] + ".chunk.js";
};